export default __webpack_public_path__ + "static/iphone-mockup@2x-950f4d0b91e15d831bbc5ad29d518d74.png";